// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { get, isEmpty } from 'lodash/fp';
import classNames from 'classnames';

// Utils
import { length } from '../../../../../../../../common/utils/immutableHelper';

// Selectors
import {
    currentBoardEditorsSelector,
    getBoardEditorTimesFetched,
    getBoardEditorTimesFetching,
} from '../boardEditorPanelSelector';
import { currentBoardIdSelector } from '../../../../../../../element/board/boardSelector';

// Actions
import { fetchBoardEditorTimes } from '../boardEditorPanelActions';

// Components
import BoardEditorListEntry from './BoardEditorListEntry';
import Spinner from '../../../../../../../components/loaders/Spinner';

// Styles
import './BoardEditorList.scss';

const mapStateToProps = createStructuredSelector({
    currentBoardId: currentBoardIdSelector,
    currentBoardEditors: currentBoardEditorsSelector,
    boardEditorTimesFetched: getBoardEditorTimesFetched,
    boardEditorTimesFetching: getBoardEditorTimesFetching,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchEditorTimes: (elementId) => dispatch(fetchBoardEditorTimes(elementId)),
});

const BoardEditorList = (props) => {
    const { currentBoardEditors, currentBoardId, dispatchFetchEditorTimes } = props;

    // Fetch the user viewed times on mount
    React.useEffect(() => {
        dispatchFetchEditorTimes(currentBoardId);
    }, []);

    if (isEmpty(currentBoardEditors)) {
        return (
            <div className="BoardEditorList">
                <Spinner show />
            </div>
        );
    }

    const hasMultipleEditors = length(currentBoardEditors) > 1;

    return (
        <div className="board-editor-list-container">
            <div className={classNames('BoardEditorList', { 'multi-editors': hasMultipleEditors })}>
                {currentBoardEditors.map((editor) => (
                    <BoardEditorListEntry key={get('entryId', editor)} {...props} editor={editor} />
                ))}
            </div>
        </div>
    );
};

// Similar to shouldComponentUpdate, but opposite
// This is a hack to prevent the list from jumping around while the public edit
// permissions are being updated. It's not advisable to prevent rendering in this
// way, but the alternative was far messier
// Don't update if we're transitioning
const areEqual = (prevProps, nextProps) => nextProps.transitioning;

BoardEditorList.propTypes = {
    currentBoardId: PropTypes.string,
    currentBoardEditors: PropTypes.array,
    dispatchFetchEditorTimes: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(BoardEditorList, areEqual));
